import React, { useState } from "react";
import { OrdersPanel } from "./Orders";
import { BillingPanel } from "./Billing";
import "../styles.css";
import "../reports.css";

const REPORT_TABS = [
  { id: "orders", label: "Pharmacy Orders" },
  { id: "communications", label: "Communications" },
];

const Reports = () => {
  const [activeTab, setActiveTab] = useState("orders");

  return (
    <div className="reports-wrapper">
      <aside className="reports-sidebar">
        <div className="reports-sidebar-header">
          <div className="reports-header-top">
            <div className="reports-icon">R</div>
            <div>
              <p className="reports-sidebar-title">Reports</p>
              <p className="reports-sidebar-subtitle">Credit & Communications</p>
            </div>
          </div>

          <div className="reports-menu">
            {REPORT_TABS.map((tab) => (
              <button
                key={tab.id}
                type="button"
                className={`reports-menu-item ${activeTab === tab.id ? "active" : ""}`}
                onClick={() => setActiveTab(tab.id)}
              >
                {tab.label}
              </button>
            ))}
          </div>
        </div>
      </aside>

      <section className="reports-content">
        <div className="pharmacy-container reports-content-inner">
          {activeTab === "orders" ? <OrdersPanel /> : <BillingPanel />}
        </div>
      </section>
    </div>
  );
};

export default Reports;

